import routeEventsApi from '@/api/route_events'

export default class RouteEventsRepository {
  constructor(vehicles) {
    this.vehicles = vehicles
    this.cache = {} // {uuid: {uuid: uuid, title: title, date: date}, …}

    // For caching purposes so we don't fetch data more than once
    this.fetchRange = { start: null, end: null }
  }

  async get(start, end) {
    if (this._rangeCached(start, end)) {
      return this._getCached(start, end)
    } else {
      await this._fetch(start, end)
      return this._getCached(start, end)
    }
  }

  async refetch(start, end) {
    const self = this

    // Remove cached Route Events first
    for (const [uuid, routeEvent] of Object.entries(this.cache)) {
      const routeEventDate = new Date(routeEvent.date)

      if (routeEventDate >= start && routeEventDate <= end) {
        delete self.cache[uuid]
      }
    }

    await this._fetch(start, end)
    return this._getCached(start, end)
  }

  _getCached(start, end) {
    const routeEvents = this.routeEvents.filter(function (routeEvent) {
      const routeEventDate = new Date(routeEvent.date)
      return routeEventDate >= start && routeEventDate <= end
    })

    return routeEvents
  }

  _rangeCached(start, end) {
    return this.fetchRange['start'] && start >= this.fetchRange['start'] && end <= this.fetchRange['end']
  }

  // We don't care about subsets that we already fetched for now
  async _fetch(start, end) {
    const self = this
    const routeEvents = []

    await Promise.all(
      this.vehicles.map(async vehicle => {
        const vehicleRouteEvents = await routeEventsApi.getAll({
          vehicle_uuid: vehicle.uuid,
          from: start.toISOString().split('T')[0], // something like '2024-01-01'
          to: end.toISOString().split('T')[0], // something like '2024-01-31'
        })

        vehicleRouteEvents.forEach(function (routeEvent) {
          routeEvents.push(self._serializeRouteEvent(routeEvent))
        })
      }),
    )

    routeEvents.forEach(function (routeEvent) {
      self.cache[routeEvent.uuid] = routeEvent
    })

    if (!this.fetchRange['start'] || start < this.fetchRange['start']) {
      this.fetchRange['start'] = start
    }

    if (!this.fetchRange['end'] || end > this.fetchRange['end']) {
      this.fetchRange['end'] = end
    }
  }

  _serializeRouteEvent(routeEvent) {
    return {
      title: routeEvent.template.name,
      uuid: routeEvent.uuid,
      date: routeEvent.event_date,
    }
  }

  get routeEvents() {
    return Object.values(this.cache)
  }
}
